import React, { useState, useEffect } from "react";

import { ResultProvider } from "../../dataProvider/results";
import { getResultOrigin } from "../../dataProvider/origin";
import { TYPES, SUBTYPES } from "../../envs/core";
import "./miniPactometro.scss";
import Header from "../../components/header";
import BarPactometro from "./bar";
const pp = 83;
const vox = 116;
const cs = 18;
const psoe = 94;
const podemos = 78;
const maspais = 43;
const allParties = { pp, cs, vox, psoe, podemos, maspais };

const comparisons = [
  ["psoe", "podemos", "maspais"],
  ["pp", "cs", "vox"],
  ["psoe", "cs"]
];

const MiniPactometro = ({ match }) => {
  const { year, type, electionNumber, placesIds } = match.params;

  const [resultOrigin, setResultOrigin] = useState({});

  useEffect(() => {
    getResultOrigin(year, type, electionNumber, placesIds)
      .then(historicResult => {
        setResultOrigin(historicResult);
      })
      .catch(err => {});
  }, [year, type, electionNumber]);

  return (
    <div className="miniPactometroPage">
      <Header>
        <h2>POSIBLES PACTOS <span className="featured">10-N</span></h2>
      </Header>
      {resultOrigin && resultOrigin.primary ? (
        <div className="cols">
          <ResultProvider
            active={resultOrigin.primary.active}
            year={year}
            type={type}
            subtype={
              type === TYPES.GENERAL ? SUBTYPES.CONGRESS : SUBTYPES.SINGLE
            }
            electionNumber={electionNumber}
            placeId={placesIds}
          >
            {dataResult => {
              if (dataResult && dataResult.partiesResult) {
                const parties = Object.keys(allParties).reduce(
                  (total, item) => {
                    total[item] = dataResult.partiesResult.find(
                      ({ id }) => id === allParties[item]
                    );
                    return total;
                  },
                  {}
                );
                return comparisons.map(c => {
                  const p = c.map(name => ({
                    name: parties[name] ? parties[name].partyAcronym : name,
                    color: parties[name] ? parties[name].partyColor : "#fff",
                    percent: parties[name]
                      ? (parties[name].seats * 100) / 350
                      : 0
                  }));
                  return (
                    <div className="col" key={p.name}>
                      <BarPactometro parties={p}></BarPactometro>
                    </div>
                  );
                });
              }
              return <div>loading</div>;
            }}
          </ResultProvider>
        </div>
      ) : (
        <div>loading</div>
      )}
    </div>
  );
};

export default MiniPactometro;
